import React from 'react';

import { Box, Grid, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import StyledBackButton from '../Common/StyledBackButton';
import StyledDeleteButton from '../Common/StyledDeleteButton';

const StyledGrid = styled(Grid)({
  background:
    'linear-gradient(175.46deg, rgba(255, 154, 154, 0.2) -9.81%, rgba(255, 88, 88, 0.2) 96.32%)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '11px',
});

const StyledTypography = styled(Typography)({
  '& span': {
    background:
      'var(--Alert-Sunset-Orange, linear-gradient(175deg, #FF9A9A -9.81%, #FF5858 96.32%))',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
});

interface isMicrophoneAccessModalProps {
  handleDismiss: () => void;
  handleRetry: () => void;
}

export default function MicrophoneAccessModal({
  handleDismiss,
  handleRetry,
}: isMicrophoneAccessModalProps) {
  const { t } = useTranslation();

  return (
    <Grid container maxHeight={709} flexDirection="column">
      <StyledGrid item height={167}>
        <img src="/assets/icons/microphone.svg" alt="bin" role="presentation" height={56} />
        <StyledTypography variant="title2Bold" textAlign="center">
          <span>{t('notes.microphoneAccessRequired')}</span>
        </StyledTypography>
      </StyledGrid>
      <Grid item maxHeight={542} px={4} pt={6.5} pb={4.5}>
        <Grid container spacing={5} flexDirection="column">
          <Grid item textAlign="center">
            <Typography variant="bodyRegular" color="primary" sx={{ letterSpacing: '-0.41px' }}>
              {t('notes.microphoneAccessDescription')}
            </Typography>
          </Grid>
          <Grid item>
            <Grid container justifyContent="space-between">
              <StyledBackButton
                variant="outlined"
                onClick={handleDismiss}
                // disabled={deleteUserGroupLoading}
              >
                {t('common.dismiss')}
              </StyledBackButton>
              <StyledDeleteButton
                onClick={handleRetry}
                fullWidth={false}
                // loading={deleteUserGroupLoading}
              >
                {t('common.retry')}
              </StyledDeleteButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
